import { render, staticRenderFns } from "./KolibriLoadingSnippet.vue?vue&type=template&id=8c35821e"
import script from "./KolibriLoadingSnippet.vue?vue&type=script&lang=js"
export * from "./KolibriLoadingSnippet.vue?vue&type=script&lang=js"
import style0 from "./KolibriLoadingSnippet.vue?vue&type=style&index=0&id=8c35821e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports